/** Where a screen is set up and lives once paired; outside the staff router. */
export const DISPLAY_PATH = "/display";

export const isDisplayPath = (): boolean =>
  window.location.pathname.replace(/\/+$/, "") === DISPLAY_PATH;

export const showDisplayPath = () => {
  if (!isDisplayPath()) window.history.replaceState(null, "", DISPLAY_PATH);
};
